import {server} from '../Data/BuildEnvironment'
import {HttpRequest} from '../Data/HttpRequest'
import {buildUrl} from '../Data/Http'

export function listSuggestionsForCustomer(
    customerId: number,
    search: string,
): HttpRequest {
    return {
        verb: 'GET',
        url:
            buildUrl(
                `${server}/customers/${customerId}/companies`,
                {limit: '12', search}),
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
    }
}

export function listSuggestions(search: string): HttpRequest {
    return {
        verb: 'GET',
        url: buildUrl(`${server}/companies`, {limit: '12', search}),
        headers: {
            'Accept': 'application/json',
        },
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Request/CompanyResource.ts